import React from 'react';
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import Searchbar from "../Searchbar/Searchbar";
import DownloadButton from "./DownloadButton";

const HeaderControls = React.memo(({ clubs }) => {
  return (
    <div className="header-right" style={{gap: 20}}>
      <LanguageSelector />
      <DownloadButton />
      <Searchbar clubs={clubs} />
    </div>
  );
});

HeaderControls.displayName = 'HeaderControls';

export default HeaderControls; 